module.exports = __webpack_public_path__ + "static/wholesale-top-categories-section-db636f0856321dec2985ee456f306ef7.png";